<template>
  <div id="app">
    <router-view />

    <base-loading :isShow="$store.state.isShowLoading"></base-loading>
    <base-snackbar
      :isShow="$store.state.isShowSnackbar"
      :message="$store.state.snackbarMessage"
      :type="$store.state.snackbarType"
    ></base-snackbar>
  </div>
</template>

<style lang="scss" src="@/assets/styles/styles.scss"></style>

<script>
import { BaseLoading } from "@/components/BaseLoading";
import { BaseSnackbar } from "@/components/BaseSnackbar";

export default {
  name: "App",

  data() {
    return {};
  },

  components: {
    BaseLoading,
    BaseSnackbar,
  },
};
</script>